export const GET_ALL_USERS_SUCCESS = 'get_all_users_success';
export const CHANGE_USERS_PARAMS = 'change_users_params';
export const TOGGLE_MODAL = 'toggle_modal';
export const SELECT_USER = 'select_user';
